import React from 'react';
import ReactDOM from 'react-dom';
import indexStyles from './index.scss';
import './i18n';
import { changeLanguage } from 'i18next';
import App from './App';

void indexStyles;

const getMazdaHost = (): string => {
  if (typeof window === 'undefined') return 'www.mazda.ca';
  const tryHost = (h: string | undefined | null): string | null => {
    if (!h) return null;
    const lower = h.trim().toLowerCase();
    if (lower === 'localhost' || lower === '127.0.0.1' || lower === '0.0.0.0') return null;
    if (lower === 'dev.mazda.ca' || lower === 'preprod.mazda.ca' || lower === 'www.mazda.ca') return lower;
    if (lower.endsWith('.mazda.ca')) return lower;
    return null;
  };
  try {
    if (window.parent && window.parent !== window) {
      const ph = tryHost(window.parent.location?.hostname);
      if (ph) return ph;
    }
  } catch {
    // cross-origin
  }
  return tryHost(window.location.hostname) ?? 'www.mazda.ca';
};

const EXTERNAL_STYLE_PATHS = [
  '/globalassets/static/css/main.min.css',
  '/globalassets/static/css/first.min.css',
];

const SUPPORTED_LANGUAGES = ['en', 'fr'] as const;

type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

const resolveSupportedLanguage = (language: string): SupportedLanguage | null => {
  const normalized = language.trim().toLowerCase();
  if (!normalized) {
    return null;
  }

  const baseLanguage = normalized.split('-')[0];
  if (!SUPPORTED_LANGUAGES.includes(baseLanguage as SupportedLanguage)) {
    return null;
  }

  return baseLanguage as SupportedLanguage;
};

const syncLanguageFromHost = () => {
  if (window.parent === window) {
    return;
  }

  try {
    const hostLang = window.parent.document.documentElement.lang;
    const resolvedLang = resolveSupportedLanguage(hostLang);

    if (!resolvedLang) {
      return;
    }

    document.documentElement.lang = resolvedLang;
    void changeLanguage(resolvedLang);
  } catch {
    // Ignore cross-origin iframe access errors.
  }
};

const loadExternalStyles = () => {
  const host = getMazdaHost();
  const cacheBuster = Date.now();
  EXTERNAL_STYLE_PATHS.forEach((path) => {
    const href = `https://${host}${path}?v=${cacheBuster}`;
    if (document.head.querySelector(`link[data-external-style="${href}"]`)) {
      return;
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-external-style', href);
    document.head.appendChild(link);
  });
};

loadExternalStyles();
syncLanguageFromHost();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);


